import { helper } from '@ember/component/helper';

import { eq } from 'rise-ui/utils/choice.js';

export default helper(function eqHelper(params) {
  return eq(...params);
});
